import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import {DIGITAL_SHELF_ROUTES, HOME_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import {resetCommonFilters, isLoadingCommonFilters, splitKpi, country, isSystemBusy} from "@signals"
import { TourProvider, TourTarget } from "@tour"
import DigitalShelfTable from "./Table";
import DigitalShelfEvolutionChart from "./EvolutionChart";
import DigitalShelfOverviewFilters from "./Filters";
import DigitalShelfReportFormDrawer from "./ReportForm";


export default function DigitalShelfGeneralPage() {

    const props = {
        head: `DIP Insight | ${DIGITAL_SHELF_ROUTES.TITLE}`,
        title: DIGITAL_SHELF_ROUTES.TITLE,
        subtitle: DIGITAL_SHELF_ROUTES.SUBTITLE,
        isEmpty: false,
        filters: <DigitalShelfOverviewFilters />,
        hasErrors: isSystemBusy.value,
        tourPageKey: "digitalShelfGeneral"
    }

    useEffect(() => {
        return () => resetCommonFilters()
    }, [])

    return <PageWrapper {...props}>
        <Grid container spacing={4}>

            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="ds-general-table" height={350} />
                <DigitalShelfTable />
            </Grid>

            <Grid item xs={12}>
                <DigitalShelfEvolutionChart />
            </Grid>

            <Grid item xs={12}>
                <DigitalShelfReportFormDrawer />
            </Grid>

        </Grid>
    </PageWrapper>
}